import React from 'react'
import { Navbar,Nav,NavDropdown,Form,FormControl,Button } from 'react-bootstrap'

const applyurl = "https://docs.google.com/forms/d/1JQvox_w4JTU0rvRcnRxPnfGxWmQBuq5V0LoMmVBY9Gs/"
//import "../../public/assets/fb48.svg"

class IYFAOCard extends React.Component{
    constructor(props){
        super(props);
        this.state = {  
          
        };
    
        this.openlink = this.openlink.bind(this)
      }
    
      openlink(link){
        window.open(link)
      }
    render(){
        return(
            <div className="home-card">
                {/* <div className="cardphoto">
                    {(this.props.index===1) && <img src="/assets/home-card-1.jpg" width="100%" height="100%"  />}
                    {(this.props.index===2) && <img src="/assets/home-card-2.jpg" width="100%" height="100%"  />}
                    {(this.props.index===3) && <img src="/assets/home-card-3.jpg" width="100%" height="100%"  />}
                </div> */}

                <div className="cardhead">
                    <h2 className="about-title">{this.props.title}</h2>
                    <p style={{color:"white",fontSize:"1.5em",fontFamily:"Arial"}}>{this.props.tagline}</p>
                </div>

                <div className="cardcontent">
                {
                    this.props.content.split('\n').map(
                    (paragraph) => {
                    return <p className="about-text">{paragraph}</p>;
                    })
                }
                 <div>&nbsp;</div>
                 <div style={{display:"flex",flexDirection:"column",marginLeft:"20%",marginRight:"20%"}}>
                <a href="/iypo/apply"><button className="about-goldbutton" style={{width:"100%"}} onClick={(e)=>{
                    //window.open(applyurl, '_blank', 'noopener,noreferrer');
                    //this.props.setval({pageSelected:"apply"})
                }}>APPLY NOW</button></a>
                </div>
                </div>
            </div>
        )  
    }
}

export default IYFAOCard;